if (!customElements.get('we-steps')) {
  customElements.define('we-steps', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.steps = Array.from(this.querySelectorAll('.we-step'));
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.videos = this.steps.map((s) => s.querySelector('video'));
      this.videos.forEach((v) => { if (v) { v.muted = true; v.playsInline = true; } });
      this.index = 0;
      this.visible = false;
      this.pauseUntil = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.track || this.steps.length < 2) return;
      this.steps.forEach((s, k) => s.classList.toggle('is-after', k > 0));

      this.prev && this.prev.addEventListener('click', () => { this.hold(); this.go(this.index - 1); });
      this.next && this.next.addEventListener('click', () => { this.hold(); this.go(this.index + 1); });
      this.tabs.forEach((t, i) => t.addEventListener('click', () => { this.hold(); this.go(i); }));
      ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => this.track.addEventListener(ev, () => this.hold(), { passive: true }));

      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });

      // Sonido: tocar el vídeo activa o quita el sonido
      this.querySelectorAll('[data-sound]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const v = btn.closest('.we-step').querySelector('video');
          if (!v) return;
          v.muted = !v.muted;
          btn.setAttribute('aria-pressed', String(!v.muted));
          btn.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar');
          if (!v.muted) v.play().catch(() => {});
        });
      });

      // Solo actúa cuando el carrusel está en pantalla
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.playActive();
      }, { threshold: 0.35 });
      this.io.observe(this);

      // Giro automático
      const auto = parseFloat(this.dataset.autoplay || '0');
      if (auto > 0 && !this.reduced) {
        this.timer = setInterval(() => {
          if (!this.visible || document.hidden || Date.now() < this.pauseUntil) return;
          this.go((this.index + 1) % this.steps.length);
        }, auto * 1000);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.io && this.io.disconnect();
    }
    hold() { this.pauseUntil = Date.now() + 8000; }
    go(i) {
      i = Math.max(0, Math.min(this.steps.length - 1, i));
      const s = this.steps[i];
      const left = s.offsetLeft - (this.track.clientWidth - s.clientWidth) / 2;
      this.track.scrollTo({ left, behavior: this.reduced ? 'auto' : 'smooth' });
      this.set(i);
    }
    sync() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0, dist = Infinity;
      this.steps.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (d < dist) { dist = d; best = i; }
      });
      this.set(best);
    }
    set(i) {
      if (i === this.index && this.steps[i].classList.contains('is-active')) return;
      this.index = i;
      this.steps.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.classList.toggle('is-before', k < i); s.classList.toggle('is-after', k > i); });
      this.tabs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.classList.toggle('is-done', k < i); });
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.steps.length - 1;
      this.playActive();
    }
    playActive() {
      this.videos.forEach((v, k) => {
        if (!v) return;
        if (k === this.index && this.visible) {
          v.play().catch(() => {});
        } else {
          v.pause();
          if (!v.muted) {
            v.muted = true;
            const b = this.steps[k].querySelector('[data-sound]');
            if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Activar sonido'); }
          }
        }
      });
    }
  });
}
